@let iconColorValue = iconColor();
@let componentIconValue = componentIcon();
<button
    class="gradient-button"
    [class.disabled]="disabled()"
    [class.outline]="variant() === 'outline'"
    [class.solid]="variant() === 'solid'"
    [class.square]="shape() === 'square'"
    [attr.data-color]="color()"
    [disabled]="disabled()"
    [style.height]="height() !== 'auto' ? buttonHeight() : null"
    (click)="onClick()">
    <span class="button-content" [class.icon-right]="iconPosition() === 'right'">
        @if (loading()) {
          <so-loader-ui [color]="iconColorValue ? iconColorValue : '--so-' + color()" />
        } @else if (!componentIconValue) {
          @if (icon()) {
            <so-svg-icon-ui [name]="icon()!" [color]="iconColorValue ? iconColorValue : color()" [size]="20" [fontSet]="fontSet()"/>
          }
        } @else {
          <ng-container *ngComponentOutlet="componentIconValue.class; inputs: componentIconValue.inputs" />
        }
        @if (text()) {
          <span class="button-text">{{ text() }}</span>
        }
    </span>
</button>
